



































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Input from '@shared/components/forms/inputs/input/input.vue';

@Component({
  name: 'bpc-block-access-control-badge-modal',
  components: {
    'bpc-input': Input,
  },
})
export default class BlockAccessControlBadgeModal extends Vue {
  // PROPS
  @Prop({ type: String, default: 'block-access-control-badge-modal' })
  readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Number, default: 0 }) readonly AccessControlBadgeId: number;
  public blockLoading: boolean = false;
  public blockingReason: string = '';

  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // LIFECYCLE
  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  // METHODS
  closeModal() {
    this.$emit('close-modal');
  }

  resetModal() {
    this.blockingReason = '';
    this.blockLoading = false;
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }

  onConfirm() {
    this.blockLoading = true;
    this.blockBadge(this.blockingReason);
  }

  blockBadge(blockingReason: string) {
    const path = `${this.$bpcApiRouteHelper.getEntityPath('access-control-badges')}/${
      this.AccessControlBadgeId
    }/block-badge`;

    const payload: AnyEntity = {
      blocking_reason: blockingReason,
    };

    this.$bpcApi.post(path, payload).subscribe(
      () => {
        this.resetModal();
        this.$emit('badge-blocked');
      },
      error => {
        this.blockLoading = false;
      },
    );
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.resetModal();
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }
}
